export const MODIFY_CUSTOMER_TAG = "MODIFY_CUSTOMER_TAG";
export const MODIFY_CUSTOMER_TAG_SUCCESS = "MODIFY_CUSTOMER_TAG_SUCCESS";
export const MODIFY_CUSTOMER_TAG_FAIL = "MODIFY_CUSTOMER_TAG_FAIL";
